<template>
    <div class="realcode flex_cen" @click="hide">
      <div class="realcode_con">
        <img src="https://pysq.stoss.shipook.com/imgs/mpimg/real_codecon.jpg" class="realcode_img">
        <p class="realcode_text">扫一扫添加客服微信</p>
      </div>
    </div>
</template>
<script>
export default{
    methods:{
        hide(){
            this.$emit('hide')
        }
    }
}
</script>

<style scoped>
.realcode{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.4);
}
.realcode_con{
    padding: 16px;
    background-color: #fff;
    border-radius: 10px;
}
.realcode_img{
    width: 240px;
    height: 240px;
}
.realcode_text{
    text-align: center;
    margin-top: 10px;
    font-size: 16px;
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/realcode.vue